<template>
  <div>
    <label>
      <input type="radio" :name="settingKey" :value="1" v-model.number="booleanValue" />
      <span>YES</span>
    </label>
    <label>
      <input type="radio" :name="settingKey" :value="0" v-model.number="booleanValue" />
      <span>NO</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'radio-boolean',
  props: [ 'settingKey' ],
  computed: {
    booleanValue: {
      get () {
        let configuration = this.$store.state.settingsPage.configuration
        if (this.settingKey in configuration) {
          let result = configuration[this.settingKey].value
          return configuration[this.settingKey].value
        }
        return 0
      },
      set (value) {
        let item = {
          key: this.settingKey,
          value: value
        }
        this.$store.commit('settingsPage/setConfigurationItem', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
input[type="radio"], span {
  display: inline-block;
  width: auto;
  vertical-align: middle;
  margin-top: 0;
}

label { margin-right: 20px; }

</style>



// WEBPACK FOOTER //
// src/components/Settings/controls/RadioBoolean.vue